import { Favorite, Controllers, FavoritePatch, FavoritePost } from "@infoland/iprova-api";

//state type
export interface FavoriteState {
    currentFavorites: Favorite[];
}

export function initialize(): FavoriteState {
    return {
        currentFavorites: null
    };
}

//initial state
const state: FavoriteState = initialize();

//getters for this store
const getters = {
    /**
     * The current favorite list
     * @param state The state to read from
     */
    currentFavorites(state: FavoriteState): Favorite[] {
        return state.currentFavorites;
    }
};

// mutations for this store
const mutations = {
    /**
     * Set the current favorite list
     * @param state The state to write to
     * @param favorites  the list of favorites
     */
    _currentFavorites(state: FavoriteState, favorites: Favorite[]): void {
        // undefined should become null
        if (!favorites) favorites = null;

        state.currentFavorites = favorites;
    }
};

// actions for this store
const actions = {
    /**
     * Loads the favorite list
     * @param context The context of the action
     */
    async loadFavorites(context: { commit: (path: string, value: Favorite[]) => void }): Promise<Favorite[]> {
        // load list of favorites
        const favorites = await Controllers.FavoriteController.getFavoritesAsync();

        context.commit("_currentFavorites", favorites);
        return favorites;
    },
    /**
     * Update the favorite
     * @param favorite The favorite that will be updated
     */
    async updateFavorite({ commit }, favorite): Promise<boolean> {
        return await Controllers.FavoriteController.updateFavoriteAsync(favorite.favoriteId, favorite.favoritePatch as FavoritePatch);
    },
    /**
     * Delete the favorite by id
     * @param favoriteId the id of the favorite
     */
    async deleteFavorite({ commit }, favoriteId: number): Promise<boolean> {
        return await Controllers.FavoriteController.deleteFavoriteAsync(favoriteId);
    },
    /**
     * Create a favorite
     * @param favorite The favorite that will be created
     */
    async createFavorite({ commit }, favorite): Promise<boolean> {
        return await Controllers.FavoriteController.createFavoriteAsync(favorite as FavoritePost);
    }
};

// export the namespace
export const namespace = "favorite";

// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
